import { ReduxState } from 'src/store/types';

const sanitizeProjectDiagram = (state: ReduxState): ReduxState => ({
  ...state,
  projects: {
    ...state.projects,
    projectsById: Object.fromEntries(
      Object.entries(state.projects.projectsById).map(([id, project]) => [
        id,
        {
          ...project,
          diagram: {
            id: 'redacted for user experience',
            model: null as any,
          },
        },
      ])
    ),
  },
});

const sanitizeProjectFileUpload = (state: ReduxState): ReduxState => ({
  ...state,
  projects: {
    ...state.projects,
    projectsById: Object.fromEntries(
      Object.entries(state.projects.projectsById).map(([id, project]) => [
        id,
        {
          ...project,
          fileUploadsById: Object.fromEntries(
            Object.entries(project.fileUploadsById || {}).map(
              ([fileUploadId, fileUpload]) => [
                fileUploadId,
                {
                  ...fileUpload,
                  contents: 'redacted for user experience',
                },
              ]
            )
          ),
        },
      ])
    ),
  },
});

type Sanitizer = <S>(state: S) => S;

export const stateSanitizer = <S>(state: S) =>
  (
    [sanitizeProjectDiagram, sanitizeProjectFileUpload] as Sanitizer[]
  ).reduce<S>((acc, sanitizer) => sanitizer(acc), state);
